  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
       item.removeAttribute("open");
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
  });
  });

 $(document).ready(function(){
   setTimeout(function(){
     $('#SortBy').find('option').prop('selected','false');
   $('#SortBy').find('option[value="title-ascending"]').prop('selected','selected').trigger('change');
     }, 2000);
 })
// dealer location 
 $(document).ready(function(){
  $(document).on('click', '#map_holder #map_inner path, #map_holder #map_inner rect, #map .itg-additional-states .btn.button', function() {
    var getValueState = $(this).attr('class');
    $('.state-row[data-state]').each(function() {
      var getStateElement = $(this).attr('data-state');
      if(getValueState.indexOf(getStateElement)!= -1) {
          var $container = $("html,body");
          var $scrollTo = $(this);
          $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top },300); 
      }
    });
  });
  $(document).on('click', '.dealer-input-state .dealer-input-btn button', function(e){
    e.preventDefault();
     var stateVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '-').replace(/ /g,'-');
    stateVal = stateVal.replaceAll('--', '-');
    console.log(stateVal);
    var stateurl = (window.location.href).split('?')[0];
    console.log(stateurl);
    window.location.replace(stateurl + '?state=' + stateVal);
  });
  $(document).on('click', '.dealer-input-city .dealer-input-btn button', function(e){
    e.preventDefault();
    var cityVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '-').replace(/ /g,'-');
    cityVal = cityVal.replaceAll('--', '-');
    var cityurl = (window.location.href).split('?')[0];
    window.location.replace(cityurl + '?city=' + cityVal);
  });
  $(document).on('click', '.dealer-input-dealer .dealer-input-btn button', function(e){
    e.preventDefault();
    var dealerVal = $(this).parent('.dealer-input-btn').find('input').val().toLowerCase().replaceAll('&', '').replaceAll("'", "").replaceAll(',', '').replaceAll('.', '').replace(/ /g,'-');
    var dealerVal = dealerVal.replaceAll('--', '-');
    var dealerurl = (window.location.href).split('?')[0];
    window.location.replace(dealerurl + '?dealer=' + dealerVal);
  });
  $(document).on('click', '.dealer-input-zipcode .dealer-input-btn button', function(e){
    e.preventDefault();
    var zipcodeVal = $(this).parent('.dealer-input-btn').find('input').val();
    zipcodeVal = zipcodeVal.replaceAll('--', '-');
    console.log(zipcodeVal);
    var zipcodeurl = (window.location.href).split('?')[0];
    console.log(zipcodeurl);
    window.location.replace(zipcodeurl + '?zip=' + zipcodeVal);
  });
});
  if(window.location.href.indexOf('?state=')!= -1){
    var stateHref = (window.location.href).split('=')[1];
    if(stateHref === null || stateHref === undefined || stateHref === ''){}else{
    $('body').addClass('locate-by-state');
    $('.dealer-locator-main .state-wrapper .state-row').each(function(){
      var stateAttr = $(this).attr('data-state');
      if(stateAttr.indexOf(stateHref)!= -1){
        $(this).show();
      }else{
        $(this).hide();
      }
    });
    }
  }
  if(window.location.href.indexOf('?city=')!= -1){
    var cityHref = (window.location.href).split('=')[1];
    if(cityHref === null || cityHref === undefined || cityHref === ''){}else{
    $('body').addClass('locate-by-city');
    $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
      var cityAttr = $(this).attr('data-city');
      if(cityAttr.indexOf(cityHref)!= -1){
        $(this).parents('.state-row').addClass('active');
        $(this).addClass('sub-active');
      }
    });
    }
  }

  if(window.location.href.indexOf('?dealer=')!= -1){
    var dealerHref = (window.location.href).split('=')[1];
    if(dealerHref === null || dealerHref === undefined || dealerHref === ''){}else{
      $('body').addClass('locate-by-dealername');
      $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
        var dealerAttr = $(this).attr('data-dealer');
        console.log(dealerAttr);
        if(dealerAttr.indexOf(dealerHref)!= -1){
          console.log('stateAttr');
          $(this).parents('.state-row').addClass('active');
          $(this).addClass('sub-active');
        }
      });
    }
  }
  if(window.location.href.indexOf('?zip=')!= -1){
    var zipcodeHref = (window.location.href).split('=')[1];
    if(zipcodeHref === null || zipcodeHref === undefined || zipcodeHref === ''){}else{
    $('body').addClass('locate-by-zipcode');
    $('.dealer-locator-main .state-wrapper .state-row .state-dealer-details').each(function(){
      var zipcodeAttr = $(this).attr('data-zipcode');
      if(zipcodeAttr.indexOf(zipcodeHref)!= -1){
        // console.log('stateAttr');
        $(this).parents('.state-row').addClass('active');
        $(this).addClass('sub-active');
      }
    });
    }
  }
   $('.ITGmega-menu').hover(function(){
    var dynamicId = $(this).attr('data-src');

    $(this).closest('.mega-menu__list,.header__submenu').find('.ItgMenuImage img').attr('src',dynamicId)
     
   

  });
 

// monogram popup
$(document).ready(function(){
   if($(document).find('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').hasClass('disabled')){
      setTimeout(function() {
      document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.add('disable');
      }, 3000); 
    }
  $(document).on('click','.personalized_button .mw-option__container .mw-option__value:first-of-type', function(e){
    e.preventDefault();
    $(this).addClass('hasClass_active');
    $(this).siblings().removeClass('hasClass_active');
    $('.mw-option.Engraving__field').show();
    $('.mw-option.Monogram__field').hide();
  });
  $(document).on('click','.personalized_button .mw-option__container .mw-option__value:nth-child(2)', function(e){
    e.preventDefault();
    $(this).addClass('hasClass_active');
    $(this).siblings().removeClass('hasClass_active');
    $('.mw-option.Engraving__field').hide();
    $('.mw-option.Monogram__field').show();
  });
  $(document).on('click','.personlize_btn button',function(){
      $('.button_section_main .modal_view_main').addClass('show');
      $('body').addClass('customize_product');
      if ($('#normal_product').length === 0) {
        $('.button_section_main .form').append('<input type="hidden" name="properties[engraving_product]" value="Yes" id="normal_product">');
      }
     var value=document.querySelector('.personalized_button .mw-stack__item:nth-child(2) .mw-option__container .mw-option__value');
    
    if(value){
     value.click();
    $('.modal_view_main.customize_product .product-form__submit.mw-apo-add-to-cart-cloned').addClass('disable');
    }
  });
 $(document).on('click','.modal_view_main.show .close_btn, .modal_view_inner .close',function(){
     $('.button_section_main .modal_view_main').removeClass('show');
     $('.engraving_image.personalize_image').hide();
     $('.monogram_image.personalize_image').hide();
     $('.modal_view_main.customize_product .product-form__submit.mw-apo-add-to-cart-cloned').removeClass('disable');
     $('body').removeClass('customize_product');
     $('#normal_product').remove();
  });
  $(document).on('click','.personalized_button .mw-option__value',function(){
      var text=$(this).find('.mw-option__value-text').text();
      $(this).addClass(text);
      if(text=='Engraving'){
        if ($('.engraving_text input').val() !== '' && $('.Engraving__field textarea').val() !== '' && $('.Engraving__field select').val() !== '') {
          document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.remove('disable');
        }else{
          document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.add('disable');
        }
        $('.engraving_image.personalize_image').show();
        $('.Engraving__field').addClass('active_element');
        
        if($('.Engraving__field').hasClass('active_element')){
          var required = document.querySelectorAll('.required_class');
          var numberOfElements = required.length;
          var input_text= $('.mw-option--type-text.Engraving__field.engraving_text.active_element').find('.mw-option__control[type="text"]');
          var input_textarea = $('.mw-option--type-textarea.Engraving__field.active_element').find('textarea.mw-option__control'); 
          var select_option = $('.mw-option--type-select.Engraving__field.active_element').find('.mw-option__control--type-select .mw-option__value').val(); 
         
           if(input_text.length > 0){
             $('.mw-option--type-text.Engraving__field.engraving_text.active_element .mw-option__control[type="text"]').addClass('required_class');  
           }

           document.querySelector('.mw-option--type-text.Engraving__field.engraving_text.active_element .mw-option__control[type="text"]').addEventListener('input', function() {
             var parentText=document.querySelector('.Engraving__field .mw-option--type-text.active_element .mw-option__container .mw-option__value');
              if (this.value.trim() == '') {
                this.classList.add('required_class');  
                this.classList.add('color_change');  
              } else {
                this.classList.remove('required_class');
                this.classList.remove('color_change');  
              }
             checkButtonEngraving();
            });

          if(input_textarea.length > 0){
             $('.mw-option--type-textarea.Engraving__field.active_element textarea.mw-option__control').addClass('required_class');  
           }
           document.querySelector('.mw-option--type-textarea.Engraving__field.active_element textarea.mw-option__control').addEventListener('input', function() {
              if (this.value.trim() == '') {
                this.classList.add('required_class');  
                this.classList.add('color_change');  
              } else {
                this.classList.remove('required_class');
                this.classList.remove('color_change');  
              }
             checkButtonEngraving();
            });

           if (select_option == '') {
              $('.mw-option--type-select.Engraving__field.active_element .mw-option__control').addClass('required_class');  
           }

            document.querySelector('.mw-option--type-select.Engraving__field.active_element select.mw-option__control').addEventListener('change', function() {
              const selectedOption = this.options[this.selectedIndex];
              if (selectedOption.value === '') {
                this.classList.add('required_class');  
                this.classList.add('color_change');  
              } else {
                this.classList.remove('required_class');
                this.classList.remove('color_change');  
              }
             checkButtonEngraving();
            });
           
              
        }
        
      }else{
        $('.engraving_image.personalize_image').hide();
        $('.Engraving__field').removeClass('active_element');
      }
     
      if(text == 'Monogram'){
          if ($('.monogram_text input').val() !== '' && $('.Monogram__field textarea').val() !== '' && $('.Monogram__field select').val() !== '') {
            document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.remove('disable');
          }else{
            document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.add('disable');
          }
            //console.log('mmm_click');

        $('.monogram_image.personalize_image').show();
        $('.Monogram__field').addClass('active_element');
        
        if($('.Monogram__field').hasClass('active_element')){
          var required = document.querySelectorAll('.required_class');
          var numberOfElements = required.length;
          var input_text= $('.Monogram__field.mw-option--type-text.monogram_text.active_element').find('.mw-option__control[type="text"]');
          var input_textarea = $('.Monogram__field.mw-option--type-textarea.active_element').find('textarea.mw-option__control'); 
          var select_option = $('.Monogram__field.mw-option--type-select.active_element').find('.mw-option__control--type-select .mw-option__value').val(); 
         
           if(input_text.length > 0){
             $('.Monogram__field.mw-option--type-text.monogram_text.active_element .mw-option__control[type="text"]').addClass('required_class');  
           }

           document.querySelector('.Monogram__field.mw-option--type-text.monogram_text.active_element .mw-option__control[type="text"]').addEventListener('input', function() {
             var parentText=document.querySelector('.Monogram__field.mw-option--type-text.active_element .mw-option__container .mw-option__value');
              if (this.value.trim() == '') {
                this.classList.add('required_class');  
                this.classList.add('color_change');  
              } else {
                this.classList.remove('required_class');
                this.classList.remove('color_change');  
              }
             checkButtonMonogram();
            });

          if(input_textarea.length > 0){
             $('.Monogram__field.mw-option--type-textarea.active_element textarea.mw-option__control').addClass('required_class');  
           }
           document.querySelector('.Monogram__field.mw-option--type-textarea.active_element textarea.mw-option__control').addEventListener('input', function() {
              if (this.value.trim() == '') {
                this.classList.add('required_class');  
                this.classList.add('color_change');  
              } else {
                this.classList.remove('required_class');
                this.classList.remove('color_change');  
              }
             checkButtonMonogram();
            });

           if (select_option == '') {
              $('.Monogram__field.mw-option--type-select.active_element .mw-option__control').addClass('required_class');  
           }

            document.querySelector('.Monogram__field.mw-option--type-select.active_element select.mw-option__control').addEventListener('change', function() {
              const selectedOption = this.options[this.selectedIndex];
              if (selectedOption.value === '') {
                this.classList.add('required_class');  
                this.classList.add('color_change');  
              } else {
                this.classList.remove('required_class');
                this.classList.remove('color_change');  
              }
             checkButtonMonogram();
            });

        }

        
      }else{
        $('.monogram_image.personalize_image').hide();
        $('.Monogram__field').removeClass('active_element');
      }
    });

  function checkButtonEngraving() {
    var required = document.querySelectorAll('.Engraving__field .required_class');
    var numberOfElements = required.length;
    if(numberOfElements == 0){
      document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.remove('disable');
    }else{
      document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.add('disable');
    }
  }

  function checkButtonMonogram() {
    var required = document.querySelectorAll('.Monogram__field .required_class');
    var numberOfElements = required.length;
    if(numberOfElements == 0){
      document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.remove('disable');
    }else{
      document.querySelector('.custom_add_to_cart .product-form__submit.mw-apo-add-to-cart-cloned').classList.add('disable');
    }
  }


   $(document).on('change', '.Engraving__field.Engraving_qty_required input[type="checkbox"]', function() {
    if ($(this).is(':checked')) {
      $('.mw-option--type-checkbox.mw-option--required.Engraving__field.Engraving_qty_required .mw-option__container .mw-option__value .mw-stack.mw-stack--vertical.mw-stack--spacing-tight>.mw-stack__item:last-child').hide();
    } else {
      $('.mw-option--type-checkbox.mw-option--required.Engraving__field.Engraving_qty_required .mw-option__container .mw-option__value .mw-stack.mw-stack--vertical.mw-stack--spacing-tight>.mw-stack__item:last-child').show();
    }
  });

  $(document).on('change', '.Monogram__field.Monogram_qty_required input[type="checkbox"]', function() {
    if ($(this).is(':checked')) {
      $('.mw-option--type-checkbox.mw-option--required.Monogram__field.Monogram_qty_required .mw-option__container .mw-option__value .mw-stack.mw-stack--vertical.mw-stack--spacing-tight>.mw-stack__item:last-child').hide();
    } else {
      $('.mw-option--type-checkbox.mw-option--required.Monogram__field.Monogram_qty_required .mw-option__container .mw-option__value .mw-stack.mw-stack--vertical.mw-stack--spacing-tight>.mw-stack__item:last-child').show();
    }
  });
  
  });


//Draft Order 
const draft_order_button = document.getElementById('draft_product_order_form');

if (draft_order_button) {
    const cartdata = document.querySelector('.cartdata').value;
    const email = document.querySelector('.cartemail').value;
    const discountName = document.querySelector('.discountName').value;
    const discountPrice = document.querySelector('.discountPrice').value;
    document.getElementById('draft-order-form').addEventListener('submit', function(event) {
      event.preventDefault();
      const cartnote = document.querySelector('.cart__note textarea').value;
      const formData = new FormData();
      formData.append('cartdata', cartdata);
      formData.append('cartnote', cartnote);
      formData.append('customerid', email);
      formData.append('discountCode', discountName);
      formData.append('discountPrice', discountPrice);
      const loader = document.querySelector('.loader_option');
      loader.style.display = 'block'; 
      fetch(this.action, {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        if(data.status == 'success') {
          localStorage.setItem("cartStatus", "1");
          window.location.href = "https://orrefors-4780.myshopify.com/pages/net-orders-thank-you";
        } else {
          location.reload();
        }
      })
    });
}




